<template>
  <v-container v-if="diary">
    <overlay-loader :overlay="loading" />
    <button 
      class="diaryDetailButton mb-8"
      @click="$router.go(-1)"
    >이전으로</button>
    <!-- <h2 
      class="customTitle"
      v-text="$store.getters.userType == 'helper' ? '파트너의 일기' : '나의 일기'"
    ></h2> -->
     <h2 
      class="customTitle"
      v-text="userType == 'helper' ? '파트너의 일기' : '나의 일기'"
    ></h2>
    <div class="diaryDetail" v-if="diary">
      <p class="diaryDate">{{ diary.written_at }}</p>
      <p class="diaryTitle">제목 : {{ diary.title }}</p>
      <p class="diaryDesire">흡연욕구 : {{ diary.desire }}0%</p>
      <div class="diaryText" v-html="diary.text"></div>

      <p id="comment">{{ diary.comment }}</p>
      <div 
        v-if="diary.stamp" 
        class="stamp"
      >
        <img 
          :src="diary.stamp.image"
          alt=""
        >
      </div>
    </div>
    <!-- <diary-check 
      v-if="!$store.getters.finished && $store.getters.userType == 'helper' && diary.is_passed === null"
      @close="dialog = false" 
      @save="pass" 
    /> -->
    <diary-check 
      v-if="userType == 'helper'"
      @close="dialog = false" 
      @save="pass" 
    />
  </v-container>
</template>

<script>
import OverlayLoader from "../OverlayLoader.vue";
import DiaryCheck from "./DiaryCheck.vue";
export default {
  name: "DiaryDetail",
  components: {
    OverlayLoader,
    DiaryCheck,
  },
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
    diaryId() {
      return this.$route.query.id;
    },
  },
  data() {
    return {
      loading: true,
      diary: undefined,
      dialog: true,
      finished: false,
      userType: undefined,
    };
  },
  methods: {
    getDiary() {
      // this.$axios
      //   .get("/challenges/" + this.challengeId + "/diaries/" + this.diaryId)
      //   .then((response) => {
      //     this.diary = response.data;
      //     this.loading = false;
      //   });
      const localStorageUser = window.localStorage.getItem("pushToken");
      if(localStorageUser == "challengertoken"){
        this.userType = "challenger";
      }else{
        this.userType = "helper";
      }
      this.diary = {
        written_at: "2023-08-12",
        title: "일기 제목입니다.",
        desire: 8,
        text: "일기 내용을 씁니다.",
        comment: "참 잘했어요.",
        is_passed: null,
        stamp: {
          image: require("@/assets/images/diary/stamp.png")
        }
      };
      this.loading = false;
    },
    pass(passed, stampId, comment) {
      this.dialog = false;

      // this.$axios
      //   .post(
      //     "/challenges/" +
      //       this.challengeId +
      //       "/diaries/" +
      //       this.diaryId +
      //       "/pass",
      //     { passed: passed, comment: comment, stamp: stampId }
      //   )
      //   .then((response) => {
      //     this.diary = response.data;
      //     this.loading = false;
      //   });
      this.loading = false;
    },
  },
  mounted() {
    this.getDiary();
  },
};
</script>

<style scoped lang="scss">
.diaryDetailButton{
  width: 32px;
  height: 32px;
  border-radius: 100%;
  text-indent: -9999px;
  background: url('../../assets/images/common/icon_arrow_white.svg') no-repeat center center #FFB5CC;
}
.diaryDetail{
  margin: 0 -20px;
  div, p, span{
    font-family: UhBee-mysen, 'Fighting_hyonam';
    word-break: break-all;
  }
  >p{
    padding: 8px 36px;
    margin-bottom: 0;
  }
  .diaryDate{
    border-top: 1px solid #FFB5CC;
    border-bottom: 1px solid #ccc;
    font-size: 40px;
    font-weight: bold;
    background-color: #f2f2f2;
  }
  .diaryTitle{
    border-bottom: 1px solid #ccc;
    font-size: 32px;
    font-weight: bold;
  }
  .diaryDesire{
    border-bottom: 1px solid #ccc;
    margin-bottom: 0;
    font-size: 32px;
    text-align: right;
    background: url('../../assets/images/diary/diary_detail_background.png') no-repeat calc(100% - 32px) calc(100% - 12px);
  }
  .diaryText{
    padding: 0 32px;
    font-size: 32px;
    font-weight: bold;
    background: repeating-linear-gradient(#ccc, #ccc 1px , #fff 0, #fff 65px);
    background-position-y: 64px;
    line-height: 65px;
  }
}
#comment {
  padding: 0 32px;
  color: #CE0C0C;
  font-size: 30px;
  text-align: right;
  letter-spacing: -0.5px;
  word-break: keep-all;
  font-family: 'Hardworking';
  background: repeating-linear-gradient(#ccc, #ccc 1px , #fff 0, #fff 65px);
  background-position-y: 64px;
  line-height: 65px;
}
.stamp{
  height: 130px;
  background: repeating-linear-gradient(#ccc, #ccc 1px , #fff 0, #fff 65px);
  background-position-y: 64px;
  line-height: 65px;
  text-align: right;
  
  img{
    max-width: 130px;
    padding: 12px;
    object-fit: cover;
  }
}
.diaryDetailButtonBox2{
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: space-between;

  .diaryDetailButton2{
    width: 100%;
    padding: 20px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Noto Sans KR';
    text-align: center;
    background-color: #FFB5CC;

    &.gray{
      background-color: #b6b6b6;
    }
  }
}
</style>
<style lang="scss">
.diaryDetail{
  .diaryText{
    font-family: UhBee-mysen, 'Fighting_hyonam';

    span, p, div{
      margin-bottom: 0;
      font-family: inherit;
    }
  }
}
</style>